/* eslint-disable no-useless-escape */
export const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+{}\[\]<>?]).{24,}$/;
export const PASSWORD_VALIDATION_MESSAGE = 'Password must be at least 24 characters long and include at least one lowercase letter, one uppercase letter, one number, and one special character (!@#$%^&*()_+{}[]<>?)';
